@if (hasMessage) {
	<section class="cue-section cue-section--result">
		<span class="cue-step-label">Resultado</span>
		<p-message [severity]="severity" [text]="title" styleClass="mb-3"></p-message>

		@if (body) {
			<p class="pre-wrap">{{ body }}</p>
		}
	</section>
}
